export const getAllValuesFromObj = (obj: Record<string, unknown>) => {
  const values = Object.values(obj);
  return values.filter((value) => !!value).join('');
};
